import ExternalLink from '../components/ExternalLink'
import { Page } from './types'

const render = () => (
    <>
        <p>We provide standard Docker images for Gurobi Cluster Manager. You can find these
            images <ExternalLink href="https://hub.docker.com/r/gurobi/manager">on our 
            Docker Hub pages</ExternalLink>. The source code for these images is available from
            our <ExternalLink href="https://github.com/Gurobi/docker-manager">Github account</ExternalLink>.
        </p>
    </>    
)

const DockerClusterManager : Page<{}> = { key: 'docker-cluster-manager', title: 'Docker image for Cluster Manager', render }

export default DockerClusterManager